import React from 'react';

export const TicketStatusNoteModal = ({
    isOpen,
    title,
    subtitle,
    status,
    statusOptions = [],
    allowStatusEdit = false,
    onStatusChange,
    note,
    onNoteChange,
    isPublic,
    onIsPublicChange,
    attachments = [],
    onAttachmentsChange,
    onAttachmentRemove,
    isSaving,
    error,
    onClose,
    onSubmit,
    submitLabel = 'Guardar',
}) => {
    if (!isOpen) return null;

    const statusLabel = statusOptions.find((option) => option.value === status)?.label || status || '-';

    return (
        <>
            <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} disabled={isSaving} />
                        </div>

                        <div className="modal-body">
                            {subtitle && <p className="text-muted mb-2">{subtitle}</p>}

                            <div className="mb-3">
                                <label className="form-label">Estatus</label>
                                {allowStatusEdit ? (
                                    <select
                                        className="form-select form-select-sm"
                                        value={status}
                                        onChange={(event) => onStatusChange?.(event.target.value)}
                                        disabled={isSaving}
                                    >
                                        <option value="">Selecciona un estatus</option>
                                        {statusOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <div className="form-control bg-light">{statusLabel}</div>
                                )}
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Nota de seguimiento</label>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    value={note}
                                    onChange={(event) => onNoteChange?.(event.target.value)}
                                    placeholder="Escribe la nota del cambio..."
                                    disabled={isSaving}
                                />
                            </div>

                            <div className="mb-3 d-flex align-items-center gap-2">
                                <input
                                    id="status-note-public"
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={Boolean(isPublic)}
                                    onChange={(event) => onIsPublicChange?.(event.target.checked)}
                                    disabled={isSaving}
                                />
                                <label htmlFor="status-note-public" className="form-check-label">Seguimiento público</label>
                            </div>

                            <div className="mb-2">
                                <label className="form-label">Adjuntos (opcional)</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    multiple
                                    onChange={(event) => onAttachmentsChange?.(Array.from(event.target.files || []))}
                                    disabled={isSaving}
                                />
                            </div>

                            {attachments.length > 0 && (
                                <div className="d-flex flex-wrap gap-2 mt-2">
                                    {attachments.map((file, index) => (
                                        <span key={`${file.name}-${index}`} className="badge bg-soft-primary text-primary d-inline-flex align-items-center gap-2">
                                            <span>{file.name}</span>
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 text-primary lh-1"
                                                onClick={() => onAttachmentRemove?.(index)}
                                                disabled={isSaving}
                                            >
                                                ×
                                            </button>
                                        </span>
                                    ))}
                                </div>
                            )}

                            {error && <div className="alert alert-danger py-2 mt-3 mb-0" role="alert">{error}</div>}
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-brand" onClick={onClose} disabled={isSaving}>
                                Cancelar
                            </button>
                            <button type="button" className="btn btn-primary" onClick={onSubmit} disabled={isSaving}>
                                {isSaving ? 'Guardando...' : submitLabel}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </>
    );
};
